/**
 * Orders table tab enum, derived from VehicleExternalStatus
 */
var OrdersTableTab;
(function (OrdersTableTab) {
    OrdersTableTab["ALL"] = "all";
    OrdersTableTab["PENDING"] = "pending";
    OrdersTableTab["SALES_PROCESSING"] = "sales-processing";
    OrdersTableTab["KICK_OFF_FULFILLMENT"] = "kick-off-fulfillment";
    OrdersTableTab["IN_FULFILLMENT"] = "in-fulfillment";
    OrdersTableTab["FULFILLED"] = "fulfilled";
    OrdersTableTab["CANCELED"] = "canceled";
})(OrdersTableTab || (OrdersTableTab = {}));

export { OrdersTableTab };
//# sourceMappingURL=OrdersTableTab.js.map
